import React, { memo } from "react";

const Error = ({ className, children, ...props }) => {
  return (
    <span className={`text-danger ${className}`} {...props}>
      {children}
    </span>
  );
};

export default memo(Error);
